import { atom } from '@reatom/framework'
import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled, { css } from 'styled-components'

import { BackOfficePremiumChangeForm } from '@root/features/back-office/premium/ui/back-office-premium-change-form'
import { BackOfficeUsersTable } from '@root/features/back-office/users-table/ui/back-office-users-table'
import { useTranslation, type TransKey } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'

import { Board } from './board'

type BackOfficeTab = 'users' | 'premium'
const BackOfficeTabs = ['users', 'premium'] as const
const backOfficeTabAtom = atom<BackOfficeTab>('users', 'backOfficeTabAtom')

export const BackOfficeBoard = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(backOfficeTabAtom)

  return (
    <Board>
      <UnderlineTabs
        value={tab}
        onChange={setTab}
        css={css`
          padding-inline: 8px;
          text-transform: capitalize;
          display: flex;
          --tab-padding-inline: 5px;
        `}
      >
        {BackOfficeTabs.map((tab) => (
          <UnderlineTabs.Tab key={tab} value={tab}>
            <Label>{t(TAB_TRANSLATION[tab])}</Label>
          </UnderlineTabs.Tab>
        ))}
      </UnderlineTabs>

      {TAB_MAP[tab]}
    </Board>
  )
}

const Label = styled.span`
  white-space: nowrap;
`

const TAB_MAP: Record<BackOfficeTab, React.ReactNode> = {
  users: <BackOfficeUsersTable />,
  premium: <BackOfficePremiumChangeForm />,
}
const TAB_TRANSLATION: Record<BackOfficeTab, TransKey> = {
  users: 'common.users',
  premium: 'common.premium',
}
